const DRAFT_URL = reverse('drafting');
const savedTempl = require('./partials/drafting/saved.mustache');
const errorTempl = require('./partials/drafting/error.mustache');
const { Confirm, Notify } = require('./components/modals');

const STRINGS = {
	draft_saved: gettext('Draft saved'),
	draft: gettext('Draft'),
	draft_delete: gettext('Delete current draft'),
	logged_out: gettext('You are currently logged out'),
	error: gettext('Error: Drafting mode disabled'),
};

class Drafting {
	static getHash(obj) {
		return JSON.stringify(obj);
	}

	cacheElements() {
		const elements = {};

		document.querySelectorAll('*[name]').forEach((el) => {
			const name = el.getAttribute('name');
			const type = el.getAttribute('type');
			if (!elements[name]) {
				elements[name] = {
					name,
					type,
					el,
					children: {},
				};
			}
			if (type === 'checkbox' || type === 'radio') {
				elements[name].children[el.value] = el;
			}
		});
		return elements;
	}

	static populateForm(serialized, elements) {
		const change = new Event('change', { bubbles: true, cancelable: true });
		const loaded = new Event('draft-loaded', { bubbles: true, cancelable: true });

		serialized.forEach((entry) => {
			const elementItem = elements[entry.name];
			const { el } = elementItem;
			const type = el.getAttribute('type');
			const { value, state } = entry;
			switch (type) {
			case 'checkbox':
				if (state) {
					elementItem.children[value].checked = state === 'on';
					elementItem.children[value].dispatchEvent(change);
				}
				break;

			case 'radio':
				elementItem.children[value].checked = true;
				elementItem.children[value].dispatchEvent(change);
				break;

			case 'hidden':
				if (el.classList.contains('sma-i18n-field') || el.classList.contains('sma-i18n-richtext-field') ) {
					el.value = value;
					el.dispatchEvent(change);
				}
				break;

			default:
				if (value === '' && el.value.length > 0) {
					// Don't blank out existing strings
					break;
				}
				el.value = value;
				el.dispatchEvent(change);
			}

			el.dispatchEvent(loaded);
		});
	}

	constructor(form) {
		this.errors = {
			400: 'invalid',
			500: 'serverError',
		};

		this.loggedOutNotified = false;
		this.form = form;
		this.updateTimeout = null;
		this.path = form.data('sma-js-drafting-path') || window.location.toString();
		this.scope = form.data('sma-js-drafting-scope') || 'admin';
		this.target = form.data('sma-js-drafting-target') || null;
		this.isSaving = false;
		this.disabled = false;

		this.element = $('<div></div>', { class: 'sma-draft-notification' });

		this.placeElement();
		this.initial = this.serializeForm();
		this.load();
	}

	placeElement() {
		if ($('.sma-button-footer').length > 0) {
			$('.sma-button-footer-right').prepend(this.element);
		} else if ($('.sma-nav').length > 0) {
			$('.sma-nav .sma-navbar-name').after(this.element);
		} else if ($('#survey').length > 0) {
			$('#survey').prepend(this.element.css('float', 'right'));
		} else {
			this.form.prepend(this.element);
		}
	}

	bindElement(el) {
		$(el).bind('change input', (e) => {
			if (this.updateTimeout) {
				clearTimeout(this.updateTimeout);
			}

			const delay = e.type === 'change' ? 5000 : 10000;

			this.updateTimeout = setTimeout(() => {
				this.update(e, $(e.currentTarget));
			}, delay);
		});
	}

	/**
	 * This is to bind the functionality UI events.
	 *
	 * @memberof Drafting
	 */
	bind() {
		this.form.find('[name]').each((i, el) => {
			this.bindElement(el);
		});

		this.element.delegate('.sma-js-delete-draft', 'click', () => {
			/* eslint-disable no-new */
			new Confirm(
				gettext('Delete draft'),
				gettext('Are you sure you want to delete this draft?'),
				() => {
					this.deleteDraft(true);
				},
			);
			/* eslint-enable no-new */
		});

		this.form.submit(() => {
			this.disabled = true;

			if (this.updateTimeout) {
				clearTimeout(this.updateTimeout);
			}

			this.deleteDraft(false);

			return true;
		});
	}

	load() {
		$.get(DRAFT_URL, {
			path: this.path,
			scope: this.scope,
			target: this.target,
		}, (response) => {
			if (response.status >= 400 && response.status <= 499) {
				this.notifyError(response, this.errors['400']);
			} else if (response.status >= 500 && response.status <= 599) {
				this.notifyError(response, this.errors['500']);
			} else if (response.success) {
				this.loaded(response);
			}
			this.bind();
		}, 'json');
	}

	loaded(response) {
		this.element.text(gettext('Loading draft...'));

		try {
			const elements = this.cacheElements();
			Drafting.populateForm(response.fields, elements);
		} catch (e) {
			this.notifyError(response, this.errors['500']);
		}

		this.lastHash = Drafting.getHash(response.fields || {});
		this.notifyLoaded(response);
	}

	serializeForm() {
		let data = _.filter(
			this.form.serializeArray(),
			(item) => item.name !== 'csrfmiddlewaretoken',
		);

		data = data.concat(
			$('input[type=checkbox]', this.form).map(
				(index, checkbox) => ({
					name: checkbox.name,
					value: checkbox.value,
					state: ($(checkbox).is(':checked') ? 'on' : 'off'),
				}),
			).get(),
		);

		return data;
	}

	update() {
		if (!this.disabled) {
			const data = this.serializeForm();
			const hash = Drafting.getHash(data);

			if (hash !== this.lastHash && !this.isSaving) {
				this.lastHash = hash;
				this.isSaving = true;
				this.element.text(gettext('Saving draft...'));

				$.post(DRAFT_URL, {
					action: 'update',
					path: this.path,
					scope: this.scope,
					target: this.target,
					data: JSON.stringify(data),
				}, (response) => {
					if (response.status >= 400 && response.status <= 499) {
						this.notifyError(response, this.errors['400']);
					} else if (response.status >= 500 && response.status <= 599) {
						this.notifyError(response, this.errors['500']);
					} else if (response.success) {
						this.notify(response);
					}
					this.isSaving = false;
				}, 'json').fail((response) => {
					if (response.status === 403 || response.status === 401) {
						this.notifyError(response, this.errors['400']);
					} else {
						this.notifyError(response, this.errors['500']);
					}
				});
			}
		}
	}

	deleteDraft(reload) {
		this.element.text(gettext('Deleting...'));

		$.post(DRAFT_URL, {
			action: 'delete',
			path: this.path,
			scope: this.scope,
			target: this.target,
		}, (response) => {
			if (response.status >= 400 && response.status <= 499) {
				this.notifyError(response, this.errors['400']);
			} else if (response.status >= 500 && response.status <= 599) {
				this.notifyError(response, this.errors['500']);
			} else if (response.success) {
				this.element.empty();
				if (reload) {
					window.location.reload(true);
				}
			}
		}, 'json');
	}

	/**
	 * Update drafting messaging
	 *
	 * @param {*} response
	 * @memberof Drafting
	 */
	notify(response) {
		setTimeout(() => {
			response.strings = STRINGS;
			const el = $(savedTempl(response));
			this.element.html(el);

			if ($().tooltip) {
				el.tooltip();
			}
		}, 1000);
	}

	/**
	 * Will notify a user that they are logged out.  This can happen after an Ajax request that returns
	 * an HTTP 401.
	 *
	 * @param {*} response
	 * @memberof Drafting
	 */
	notifyError(response, errorType) {
		if (errorType === this.errors['400']) {
			if (!this.loggedOutNotified) {
				/* eslint-disable no-new */
				new Notify(
					gettext('Logged out!'),
					gettext(
						'You have been logged out by the system.  Your changes cannot be saved.  '
						+ 'Please log back in to ensure your work is not lost',
					),
					gettext('Ok'),
					() => {
					},
				);
				/* eslint-enable no-new */
				this.loggedOutNotified = true;
			}
			response.invalid = true;
		} else { // errorType === 500
			response.unknown = true;
		}

		response.strings = STRINGS;
		const el = $(errorTempl(response));
		this.element.html(el);

		if ($().tooltip) {
			el.tooltip();
		}
	}

	/**
	 * Helper method to help notify that the draft has been loaded
	 *
	 * @param {*} response
	 * @memberof Drafting
	 */
	notifyLoaded(response) {
		response.loaded = true;
		this.notify(response);
	}
}

$(() => {
	setTimeout(() => {
		$('[data-sma-js-drafting]').each((i, form) => {
			/* eslint-disable no-new */
			new Drafting($(form));
			/* eslint-enable no-new */
		});
	}, 100);
});

module.exports = Drafting;
